import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import Axios from 'axios';
import { i18n } from '../../translate/i18n';
let CancelToken = Axios.CancelToken;
let fetchBackups_cancel;

export const filterBackupClear = (model) => {
  return {
    type: actionTypes.FILTER_BACKUP_CLEAR,
    model,
  };
};

export const fetchBackupsSuccess = (backups) => {
  return {
    type: actionTypes.FETCH_BACKUPS_SUCCESS,
    backups: backups
  };
};

export const requestBackupsFail = (error) => {
  return {
    type: actionTypes.REQUEST_BACKUPS_FAIL,
    error: error
  };
};

export const requestBackupsStart = () => {
  return {
    type: actionTypes.REQUEST_BACKUPS_START
  };
};

export const updateBackupsSuccess = (backup) => {
  return {
    type: actionTypes.UPDATE_BACKUPS_SUCCESS,
    backup: backup
  }
}

export const setBackupsFilter = (page, limit, searchText, order, orderBy) => {
  return {
    type: actionTypes.SET_BACKUPS_FILTER,
    backupsFilter: {
      page, limit, searchText, order, orderBy,
    }
  };
};

export const fetchBackupByIdSuccess = (backup) => {
  return {
    type: actionTypes.FETCH_BACKUPS_BY_ID_SUCCESS,
    backup: backup
  };
}

export const fetchBackups = (page, limit, search, order, orderBy) => {
  return dispatch => {
    dispatch(requestBackupsStart());
    dispatch(setBackupsFilter(page, limit, search, order, orderBy));
    
    const  queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
  
    API.get('/backupsrealm' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchBackups_cancel = c;
      })
    }).then(res => {
      dispatch(fetchBackupsSuccess(res.data));
    })
    .catch(err => {
      dispatch(requestBackupsFail(err));
    });
  };
};

export const fetchBackupsById = (id) => {
  return dispatch => {
    dispatch(requestBackupsStart());
    API.get('/backupsrealm/' + id, {
      cancelToken: new CancelToken(function executor(c) {
        fetchBackups_cancel = c;
      })
    }).then(res => {
        dispatch(fetchBackupByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestBackupsFail(err));
      });
  };
};

export const updateBackups = (index, body, message = '') => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestBackupsStart());
      API.put('/backupsrealm/' + index, body)
        .then(res => {
          dispatch(updateBackupsSuccess(res.data));
          toastr.success(i18n.t('updateBackupsStr.toastr'), message);
          resolve('success');
        })
        .catch(err => {
          dispatch(requestBackupsFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateBackupsStr.toastrError'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

